Vendd.Scripts.load(function () {

    const getItemAttributeValuePropertyName = function(itemAttribute) {

        if (itemAttribute.IsSet) {

            return 'SetValueId';

        } else if (itemAttribute.ValueType === "Int") {

            return 'ValueInt';

        } else if (itemAttribute.ValueType === "Bool") {

            return 'ValueBool';

        } else if (itemAttribute.ValueType === "Decimal") {
            
            return 'ValueDecimal';

        } else if (itemAttribute.ValueType === "SmallText") {

            return 'ValueSmallText';

        } else if (itemAttribute.ValueType === "BigText") {

            return 'ValueBigText';

        } else if (itemAttribute.ValueType === "LargeText") {

            return 'ValueLargeText';

        } else if (itemAttribute.ValueType === "Code") {
            
            return 'ValueCodeText';

        }

        return '';

    };

    var itemAttributesHelper = function () {

    };

    
    itemAttributesHelper.prototype.getValue = function(itemAttribute) {

        if(!!!itemAttribute) {
            
            throw new Error('itemAttribute could not be null');

        }

        if(!!!itemAttribute.AttributeCode || typeof itemAttribute.AttributeCode != 'string' ||  itemAttribute.AttributeCode.length == 0) {

            throw new Error('invalid itemAttribute code');

        }

        var propertyName = getItemAttributeValuePropertyName(itemAttribute);

        if (!!!propertyName || typeof propertyName != 'string' || propertyName.length == 0) { 

            throw new Error(`Could not find value property for attribute ${itemAttribute.AttributeCode}`);

        }

        if (typeof (itemAttribute[propertyName]) === 'undefined') {

            return undefined;

        }

        // TODO: enhance for SetValues

        return itemAttribute[propertyName];

    };

    itemAttributesHelper.prototype.setValue = function(itemAttribute, value) {

        if(!!!itemAttribute) {
            
            throw new Error('itemAttribute could not be null');

        }
        
        if(!!!itemAttribute.AttributeCode || typeof itemAttribute.AttributeCode != 'string' ||  itemAttribute.AttributeCode.length == 0) {

            throw new Error('invalid itemAttribute code');

        }

        var propertyName = getItemAttributeValuePropertyName(itemAttribute, value);

        if (!!!propertyName || typeof propertyName != 'string' || propertyName.length == 0) { 

            throw new Error(`Could not find value property for attribute ${itemAttribute.AttributeCode}`);

        }

        // TODO: enhance for SetValues

        itemAttribute[propertyName] = value;

    };

    var Vendd = window.Vendd || {};

    Vendd.inlineEdit.helpers.itemAttributesHelper = itemAttributesHelper;

});